module.exports = __webpack_public_path__ + "static/media/billingActive.d2938673.svg";